<div id="header" class="d-print-none header navbar-default">
  <div class="navbar-header">
    <a href="javascript:void(0)" [routerLink]="['/admin']" class="navbar-brand"
      ><img
        src="assets/template/images/logo.png"
        class="logo-admin"
        style="height: 40px; width: auto"
    /></a>
    <button type="button" class="navbar-toggle" data-click="sidebar-toggled">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
  </div>

  <ul class="navbar-nav navbar-right">
    <li *ngIf="!!user" class="dropdown navbar-user">
      <a
        href="javascript:;"
        class="dropdown-toggle"
        data-toggle="dropdown"
        style="padding: 15px 10px"
        aria-expanded="false"
      >
        <img
          class="avataradmin"
          [src]="user.avatar_url"
          width="34"
          height="34"
        />
        <span class="d-none d-md-inline">{{ user.name }}</span
        ><b class="caret"></b>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right"
        x-placement="bottom-end"
        style="
          position: absolute;
          will-change: transform;
          top: 0px;
          left: 0px;
          transform: translate3d(104px, 50px, 0px);
        "
      >
        <a href="javascript:void(0)" (click)="logout()" class="dropdown-item">
          <b><i class="fas fa-power-off fa fa-lg"></i> CERRAR SESIÓN</b>
        </a>
        <hr />
        <!-- <a href="javascript:void(0)" class="dropdown-item">
          <b>{{ _version.full_version }}</b>
        </a> -->
      </div>
    </li>
  </ul>
</div>

<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }"
></ngx-loading>
